import gql from 'graphql-tag'

export const GET_MATERIAL_LIST = gql`
  query {
    categories {
      id
      name
      materials {
        id
        name
        baseMaterial
        cover {
          id
          url
        }
        images {
          id
          url
        }
      }
    }
    options: __type(name: "MinQuantity") {
      quantityOptions: enumValues {
        name
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/graphql/queries/Material.js